<template>
  <div>
    <nr-generic
      title="Notas de Reembolso dos Clientes em Aberto"
      namespace="refund_notes_open"
      searchObject='customer'
      :searchFields="['cost_center__social_name']"
      :showFilter="true"
      :showPagination="true"
      >
      <template v-slot:header>
        <th v-for="item in headers" :key="item.label">{{ item.label }}</th>
      </template>
      <template v-slot:item="{ item }">
        <td>
          <span v-if="item.social_name">{{ item.social_name }}</span> <span v-else>{{ item.name }}</span><br>
          <!-- <small v-if="$store.getters['auth/isAdmin']" class="text-muted" title="Criado por">{{ item.created_by }}</small> -->
        </td>
        <td>{{ item.num_open_refunds }}</td>
        <td>
          <b-button variant="success" @click="openModal(item)">
            <i class="fa fa-plus"></i> Gerar recebível
          </b-button>
        </td>
      </template>
    </nr-generic>

    <b-modal :visible="isVisible" title="Gerar Nota de Reembolso" @ok="generateNote" @hidden="clearModal" id="refund-note-modal">
      <h5 class="mb-3"><span v-if="selectedItem.social_name">{{ selectedItem.social_name }}</span><span v-else>{{ selectedItem.name }}</span><br></h5>
      <b-form-group label="Data de Vencimento">
        <datepicker
          v-model="expirationDate"
          format="dd/MM/yy"
          input-class="form-control"
          :use-utc="true"
        />
      </b-form-group>

      <div class="font-weight-bold text-right">Total: R$ {{ selectedTotal | formatPrice }}</div>

      <b-table class="mt-3" striped selectable :items="refundNotes" :fields="tableFields" @row-selected="onRowSelected" ref="the_table">
        <template v-slot:head(checkbox)="data">
          <b-form-checkbox @change="selectAll($event)" v-model="allSelected"></b-form-checkbox>
        </template>

        <template v-slot:cell(checkbox)="data">
          <b-form-checkbox :checked="data.rowSelected" @change="selectRow($event, data.index)"></b-form-checkbox>
        </template>

        <template v-slot:cell(payment_date)="data">
          {{ data.item.payment_date | formatDate }}
        </template>

        <template v-slot:cell(value)="data">
          <div class="d-flex justify-content-between" style="width: 85px;">
            <span>R$</span>
            <span>{{ data.item.value | formatPrice }}</span>
          </div>
        </template>
      </b-table>

      <div class="font-weight-bold text-right">Total: R$ {{ selectedTotal | formatPrice }}</div>
    </b-modal>
  </div>
</template>
<script>
import NRGeneric from './NRGeneric';
import axios from 'axios';

import moment from 'moment';
import 'moment/locale/pt-br';

import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    'nr-generic': NRGeneric,
    Datepicker,
  },
  data() {
    return {
      isVisible: false,
      selectedItem: {},
      refundNotes: [],
      headers: [
        { label: 'Cliente' },
        { label: 'Reembolsos' },
        { label: 'Ações' },
      ],
      selected: [],
      allSelected: false,
      expirationDate: null,
      tableFields: [
        {
          key: 'checkbox',
        },
        {
          key: 'payment_date',
          label: 'Data'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'value',
          label: 'Valor'
        },
      ],
    }
  },
  computed: {
    selectedTotal() {
      return this.selected.reduce((prev, curr) => {
        return prev + Number(curr.value);
      }, 0)
    },
  },
  methods: {
    generateNote() {
      axios.post('/financial/action/generate-refund-notes/', {
        customer_pk: this.selectedItem.customer_pk,
        selected_items_pks: this.selected.map(s => s.pk),
        expirationDate: this.expirationDate,
      })
        .then(() => {
          this.$store.dispatch('refund_notes_open/loadItems');
          this.$store.dispatch('refund_notes/loadItems');
        });
    },
    openModal(item) {
      this.isVisible = true;
      this.selectedItem = item;
      this.expirationDate = new Date().toISOString().split('T')[0];

      axios.get('/financial/refund-note/customers/' + item.customer_pk + '/without-nr/')
        .then(res => {
          this.refundNotes = res.data.data;

          setTimeout(() => {
            this.selectAll(true);
          }, 100);
        });
    },
    clearModal() {
      this.isVisible = false;
    },
    onRowSelected(items) {
      this.selected = items;

      if (this.selected.length == this.refundNotes.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    selectAll(event) {
      this.allSelected = event;

      const items = this.refundNotes;
      const theItems = [...items].map((item, i) => {
        return {
          ...item,
          index: i,
        }
      });

      const selectedPks = this.selected.map(s => s.pk);

      const indexes = theItems.filter(i => {
        if (event) {
          return !selectedPks.includes(i.pk);
        }

        return selectedPks.includes(i.pk);
      })
        .map(i => i.index);

      this.clickRows(indexes);
    },
    selectRow(event, i) {
      this.clickRows([i]);

      if (this.selected.length == this.refundNotes.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    clickRows(which) {
      let myTable = this.$refs.the_table.$el,
          tableBody = myTable.getElementsByTagName('tbody')[0],
          tableRows = tableBody.getElementsByTagName('tr')
      which.forEach(idx => {
        tableRows[idx].click()
      })
    },
  }
}
</script>

<style>
#refund-note-modal .modal-dialog {
  max-width: 70% !important;
}
</style>
